import React, { Component } from 'react'; 
class Reservaciones extends Component{ 
    componentDidMount(){
    window.startx();
  }
    render(){ 
      return (
        <div id="main" className="wrapper style1">
          <div className="container">
            <header className="major">
              <h2>Reservaciones</h2>
            </header>
            <div className="row row-reservaciones">
              <div className="grid-item justificacion col-12">
                <div className="row">
                  <div className="col-md-4">
                    <img class="revimagen" src="images/llamanos.png" alt="Llamanos"/>
                  </div>
                  <div className="col-md-8">
                    <div>
                      <h2>1.- Llama</h2>       
                      <p>Comunicarse a el área de reservaciones de <strong> 9:30 a 17:00 hrs</strong> de <strong>Lunes a Viernes.</strong></p>
                      <p>Para las reservación se requiere de <strong>mínimo 15 días hábiles antes de la fecha</strong> en la que desea hacer su visita.</p>
                      <p>Para confirmar su reservación deberá cubrir las cuotas de recuperación <strong>5 días hábiles </strong>antes de la visita <strong>SUJETO A DISPONIBILIDAD</strong> </p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <img class="revimagen" src="images/pago.png" alt='Pago'/>
                  </div>
                  <div className="col-md-8">
                    <div> 
                      <h2>2.- Realiza tu pago</h2>       
                      <p className="justificacion"><strong> EL PAGO SERÁ EN UNA SOLA EXHIBICIÓN, NO SE RECIBIRÁ NINGÚN DEPÓSITO SIN PREVIA LLAMADA PARA RESERVAR LA VISITA</strong></p>
                      <p>Depósito bancario: <strong>BBVA Bancomer </strong>número de cuenta <strong>0181038354 </strong>a nombre de <strong>Museo Interactivo para la Niñez y la Juventud Hidalguense El Rehilete</strong>.</p>
                      <p><strong>Clabe interbancaria: 01 2290 0018 1038 3549  Enviar vía correo electrónico</strong> la copia de la ficha de depósito por ambos lados, anexado el nombre de la insitutucion, la cantidad de niños y de adultos de dicho pago, la fecha y hora de la visita.  <strong>Es indispensable entregar la ficha de depósito original</strong> en el momento de su ingreso, con el fin de emitir el recibo de cuotas de recuperacion correspondiente.</p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <img class="revimagen" src="images/visita.png" alt='Visita'/>
                  </div>
                  <div className="col-md-8">
                    <div> 
                      <h2>3.- Visita</h2>       
                      <p>Los grupos escolares deberán ir acompañados de la siguiente manera: Un adulto por cada 10 alumnos como mínimo. Para realizar una resevación es necesario un mínimo de 15 personas.</p>
                      <p><strong>NO HAY NINGÚN TIPO DE CORTESÍAS </strong>.</p>
                      <p>Los grupos se reciben en dos turnos:</p>
                      <p><strong>MATUTINO: de 9:30 a 14:00 h</strong></p>
                      <p><strong>VESPERTINO: de 14:00 a 18:30 h</strong></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ); 
    } 
} 

export default Reservaciones;